import { render } from "./App.vue?vue&type=template&id=952a79f6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=952a79f6&lang=css"
import "./assets/css/color.css?vue&type=style&index=1&lang=css"
import "./assets/css/responsive.css?vue&type=style&index=2&lang=css"
import "./assets/css/style.css?vue&type=style&index=3&lang=css"
import "./assets/css/ticket.css?vue&type=style&index=4&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__